import EWidget from "@api/models/EWidget";
import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import { Stack } from "@mantine/core";
import { useMemo } from "react";
import BuyAccountWidget from "./BuyAccountWidget";
import BuySkinWidget from "./BuySkinWidget";

interface IBlogWidgetProps {
  widgetType?: EWidget;
}

const BlogWidget: React.FC<IBlogWidgetProps> = ({ widgetType }) => {
  const widget = useMemo(() => {
    if (widgetType === EWidget.WIDGET_SKIN) {
      return {
        text: "Choisis ton compte en fonction du skin !",
        widget: <BuySkinWidget />,
      };
    }

    return {
      text: "Choisis ton nouveau compte !",
      widget: <BuyAccountWidget />,
    };
  }, [widgetType]);

  return (
    <Stack gap={25}>
      <SSHeadline props={{ title: { ff: "unset" } }}>
        <SSWhiteText>{widget.text}</SSWhiteText>
      </SSHeadline>
      {widget.widget}
    </Stack>
  );
};

export default BlogWidget;
